<template>
	<v-container>
		<v-col class="col-12 text-h2">Статьи</v-col>
		<v-skeleton-loader type="list-item-two-line" v-if="loading"></v-skeleton-loader>

		<v-card v-for="(post, index) in post_script" :key="index" :href="post.link" class="my-2">
			<v-card-title>{{ post.title }}</v-card-title>
		</v-card>
		
	</v-container>
</template>





<script>

import axios from 'axios'

export default {
	name: 'Documents',
	data () {
		return {
			post_script: '',
			loading: true,
		}
	},
	computed: {},
	watch: {},
	methods: {
		getPosts() {
			//var vm = this
			var url = 'http://catahoulakennel.ru/api/v1/post/'
			axios.get(url)
			.then(response => { this.post_script= response['data'];	this.loading=false})
		},
	},
	beforeMount(){
		this.getPosts()
	},
}
</script>

